import { render, staticRenderFns } from "./OneScreen.vue?vue&type=template&id=5c9ed94c&scoped=true&"
import script from "./OneScreen.vue?vue&type=script&lang=js&"
export * from "./OneScreen.vue?vue&type=script&lang=js&"
import style0 from "./OneScreen.vue?vue&type=style&index=0&id=5c9ed94c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9ed94c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
